import AppBrandLogo from 'components/common/AppBrandLogo'
import LanguageSwitcher from 'components/common/LanguageSwitcher'

const AuthLayout = ({ children }) => {
  return (
    <div className='font-nunito min-h-screen flex items-center justify-center bg-greenPrimary'>
      <div className='absolute top-4 right-4'>
        <LanguageSwitcher variant='dark' />
      </div>
      <div className='bg-white p-8 rounded-xl shadow-md w-96 flex flex-col items-center'>
        <AppBrandLogo size='lg' className='mb-4' />
        {children}
      </div>
    </div>
  )
}

export default AuthLayout
